export default {
  methods: {
    editPreferencesUrl(user) {
      return '/permissions/' + user.uuid + '/edit';
    },
    editUserUrl(user) {
      return '/user/' + user.uuid + '/edit';
    },
  },
};
